/**
 * @fileoverview DELETE handler for the "/data_objects/:type_name/:object_id/object_relationships"
 * endpoint. The edge is identified by its natural key — direction, the related object's type and
 * object id, and the relationship kind — passed as query params (the internal row id is never used).
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameObjectIdObjectRelationships } from "./constants";
import type { DeleteCustomObjectsTypeNameObjectIdObjectRelationshipsParams } from "./types";

export const deleteCustomObjectsTypeNameObjectIdObjectRelationships = reactQueryMutationAdapter(
  customObjectsTypeNameObjectIdObjectRelationships,
  ({
    typeName,
    objectId,
    direction,
    targetTypeName,
    targetObjectId,
    relKind,
  }: DeleteCustomObjectsTypeNameObjectIdObjectRelationshipsParams): Promise<Record<string, never>> => {
    return fetch(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(objectId)}/object_relationships`,
      "DELETE",
      {},
      {
        queryParams: {
          direction,
          target_type_name: targetTypeName,
          target_object_id: targetObjectId,
          rel_kind: relKind,
        },
      },
      { propagateFetchRequestError: false }
    );
  }
);
